import React, { useState, useEffect } from 'react';
import { Paper, Button, Select, MenuItem, Grid2, Checkbox } from '@mui/material';
import palette from '../assets/sass/palette.scss';
import GamePlayerInfo from './GamePlayerInfo';
import { doc, updateDoc, Timestamp } from 'firebase/firestore';
import { useFirebase } from '../contexts/FirebaseContext';
import { Typography, Stack, Box } from '@mui/material';
import { useApi } from '../services/api';
import { clearRatingCache } from '../hooks/useWaglRating';
import LockIcon from '@mui/icons-material/Lock';
import HandshakeIcon from '@mui/icons-material/Handshake';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import GameTeeTime from './GameTeeTime';
const GameScoringMatchPlay = ({
  game,
  onFinalise,
  users,
  isOrganiser,
  onUnlock,
  matchNumber,
  matchGroupingType,
  slotPlayers,
  teaTime,
  viewOnly = false,
}) => {
  const MatchPlayLookupTable = [
    { name: 'Halved', winnerScore: 0, loserScore: 0, impact: 1 },
    { name: '1 up', winnerScore: 1, loserScore: 0, impact: 2 },
    { name: '2 & 1', winnerScore: 2, loserScore: 1, impact: 3 },
    { name: '3 & 1', winnerScore: 3, loserScore: 1, impact: 4 },
    { name: '3 & 2', winnerScore: 3, loserScore: 2, impact: 5 },
    { name: '4 & 2', winnerScore: 4, loserScore: 2, impact: 6 },
    { name: '4 & 3', winnerScore: 4, loserScore: 3, impact: 7 },
    { name: '5 & 3', winnerScore: 5, loserScore: 3, impact: 8 },
    { name: '5 & 4', winnerScore: 5, loserScore: 4, impact: 9 },
    { name: '6 & 5', winnerScore: 6, loserScore: 5, impact: 9 },
    { name: '7 & 6', winnerScore: 7, loserScore: 6, impact: 10 },
    { name: '8 & 7', winnerScore: 8, loserScore: 7, impact: 10 },
    { name: '9 & 8', winnerScore: 9, loserScore: 8, impact: 10 },
    { name: '10 & 8', winnerScore: 10, loserScore: 8, impact: 10 },
  ];

  const [gameData, setGameData] = useState({ ...game });
  const [groupedPlayers, setGroupedPlayers] = useState(new Map());
  const [groupAScore, setGroupAScore] = useState(null);
  const [groupBScore, setGroupBScore] = useState(null);
  const [isHalved, setIsHalved] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [dropdownValue, setDropdownValue] = useState('');
  const [processedPlayers, setProcessedPlayers] = useState([]);
  const { db } = useFirebase();
  const { post } = useApi();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const isFinaliseButtonDisabled =
    loading ||
    gameData.winnerScore === null ||
    gameData.loserScore === null ||
    !gameData.matches?.[matchNumber - 1]?.players?.some((player) => player?.didWin) ||
    dropdownValue === '';

  const match = gameData?.matches?.[matchNumber - 1];

  const handleUnlock = async () => {
    try {
      if (onFinalise) {
        onFinalise({
          slotPlayers,
          matchNumber,
          selectedFormat: 'match',
          format: 'match',
          matchGroupingType,
          teaTime: Timestamp.fromDate(teaTime.toDate()),
          status: 'pending',
        });
      }
    } catch (error) {
      console.error('Error unlocking match:', error);
    }
  };

  useEffect(() => {
    if (slotPlayers && users) {
      // Filter out null values and combine with user data
      const validSlotPlayers = slotPlayers.filter((player) => player !== null);
      const updatedPlayers = validSlotPlayers.map((player) => {
        const userDetails = users.find(
          (user) =>
            user?.uid === player?.uid ||
            user?.user === player?.uid ||
            user?.uid === player?.user ||
            user?.user === player?.user
        );
        console.log('users: 1', userDetails);

        return {
          ...player,
          userName:
            userDetails?.userName ||
            userDetails?.username ||
            player?.userName ||
            player?.username ||
            '',
          user: userDetails?.uid || player?.user || null,
          userId: userDetails?.uid || player?.user || null,
          photoURL: userDetails?.photoURL || player?.photoURL || null,
        };
      });
      setProcessedPlayers(updatedPlayers);
    }
  }, [slotPlayers, users]);

  useEffect(() => {
    // Validate game data structure
    if (!game || !game.id) {
      setError('Game data is not available. Please try refreshing the page.');
      setIsLoading(false);
      return;
    }

    // Initialize matches array if it doesn't exist
    const gameDataCopy = { ...game };
    if (!gameDataCopy.matches) {
      gameDataCopy.matches = [];
    }

    // Ensure the matches array has enough slots
    while (gameDataCopy.matches.length < matchNumber) {
      gameDataCopy.matches.push({
        players: [],
        status: 'pending',
      });
    }

    setGameData(gameDataCopy);
    setIsLoading(false);
    setError(null);
  }, [game, matchNumber]);

  useEffect(() => {
    if (groupAScore !== null && groupBScore !== null) {
      try {
        const _groupAScore = groupAScore === 'Halved' ? 0 : groupAScore;
        const _groupBScore = groupBScore === 'Halved' ? 0 : groupBScore;
        const valid = MatchPlayLookupTable.find(
          (option) =>
            (option.winnerScore === _groupAScore && option.loserScore === _groupBScore) ||
            (option.winnerScore === _groupBScore && option.loserScore === _groupAScore)
        );
        const gameDataCopy = { ...game };
        gameDataCopy.winnerScore = valid?.winnerScore;
        gameDataCopy.loserScore = valid?.loserScore;
        processedPlayers?.forEach((player) => {
          if (!player) return;
          const score = player.group === 'A' ? _groupAScore : _groupBScore;
          let didWin =
            (player.group === 'A' && _groupAScore > _groupBScore) ||
            (player.group === 'B' && _groupBScore > _groupAScore);

          if (_groupAScore === 0 && _groupBScore === 0) {
            didWin = true;
          }
          console.log('didWin', didWin);
          player.didWin = didWin;
          player.grossScore = didWin ? score : 0;
          player.netScore = player?.grossScore;
        });

        if (!gameDataCopy.matches) {
          console.error('Matches array is missing from game data');
          setError('Unable to process match data. Please try refreshing the page.');
          return;
        }

        if (!gameDataCopy.matches[matchNumber - 1]) {
          console.error(`Match ${matchNumber} is missing from game data`);
          setError(`Unable to find match #${matchNumber}. Please try refreshing the page.`);
          return;
        }

        gameDataCopy.matches[matchNumber - 1].players = processedPlayers;
        setError(null);
        setGameData(gameDataCopy);
      } catch (err) {
        console.error('Error processing match data:', err);
        setError(
          'An error occurred while processing the match data. Please try refreshing the page.'
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupAScore, groupBScore, processedPlayers]);

  const handleScoreMatchPlay = async () => {
    setLoading(true);
    const gameRef = doc(db, 'games', gameData.id);
    const match = gameData?.matches?.[matchNumber - 1];
    if (match) {
      match.players = match.players.map((player) => {
        if (!player) return player;
        const scoreOption = MatchPlayLookupTable.find(
          (option) =>
            (option.winnerScore === groupAScore && option.loserScore === groupBScore) ||
            (option.winnerScore === groupBScore && option.loserScore === groupAScore)
        );
        if (scoreOption) {
          return {
            ...player,
            grossScore: player.didWin ? scoreOption.winnerScore : scoreOption.loserScore,
            netScore: player.didWin ? scoreOption.winnerScore : scoreOption.loserScore,
          };
        }
        return player;
      });
      match.status = 'completed';
    }
    await updateDoc(gameRef, gameData);
    if (onFinalise) {
      if (gameData.competitive) {
        try {
          await post('/game/score-players-in-match', {
            gameId: gameData.id,
            matchNumberIndex: matchNumber - 1,
          });
          // Clear the frontend rating cache so games played count updates immediately
          clearRatingCache();
        } catch (error) {
          console.error('Error scoring players: ', error);
        }
        window.location.reload();
      }
    }
    setLoading(false);
  };

  const getUserPhotoURL = (player) => {
    return player.photoURL;
  };

  const groupPlayers = () => {
    const grouped = new Map();
    if (!processedPlayers) return;

    processedPlayers.forEach((player) => {
      if (!player) return;
      const group = player.group || '';
      if (!grouped.has(group)) {
        grouped.set(group, []);
      }
      grouped.get(group).push(player);
    });
    setGroupedPlayers(grouped);
  };

  useEffect(() => {
    groupPlayers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [processedPlayers]);

  const ScoreCheckbox = ({ name, value, onChange = () => {} }) => {
    const handleChange = (event) => {
      if (value === 'halved') {
        setIsHalved(event.target.checked);
        setSelectedGroup(null);
        if (event.target.checked) {
          setGroupAScore('Halved');
          setGroupBScore('Halved');
          setDropdownValue('Halved');
        } else {
          setGroupAScore(null);
          setGroupBScore(null);
          setDropdownValue('');
        }
      } else {
        const group = value.split('-')[1];
        setSelectedGroup(event.target.checked ? group : null);
        setIsHalved(false);
        setDropdownValue('');
      }
      onChange(event);
    };

    return (
      <Checkbox
        value={value}
        name={name}
        onChange={handleChange}
        checked={value === 'halved' ? isHalved : selectedGroup === value.split('-')[1]}
        variant="bigCheckbox"
        checkedIcon={<CheckBoxOutlinedIcon />}
      />
    );
  };

  return (
    <Paper
      elevation={0}
      variant="gameBox"
      sx={{ ...(viewOnly && { minHeight: '325px', justifyContent: 'center' }) }}
    >
      {error && (
        <Box
          sx={{
            p: 2,
            mb: 2,
            backgroundColor: '#ffebee',
            borderRadius: 1,
            border: '1px solid #ffcdd2',
          }}
        >
          <Typography color="error" sx={{ textAlign: 'center' }}>
            {error}
          </Typography>
        </Box>
      )}
      {isLoading ? (
        <Box sx={{ p: 4, textAlign: 'center' }}>
          <Typography>Loading match data...</Typography>
        </Box>
      ) : (
        <>
          <Box
            sx={{
              position: 'relative',
              textAlign: 'center',
            }}
          >
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              sx={{ justifyContent: 'space-between', width: '100%' }}
            >
              <Typography variant="moduleHeader" component="h5">
                {match?.status === 'completed'
                  ? `Match #${matchNumber} Results`
                  : isOrganiser
                  ? `Record Match #${matchNumber} Results`
                  : `Match #${matchNumber} Results`}
              </Typography>
              {/* Container for lock icon and tee time box, horizontally aligned */}
              <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
                {!viewOnly && match?.status !== 'completed' && (
                  <Box
                    onClick={!viewOnly ? handleUnlock : () => {}}
                    sx={{
                      backgroundColor: 'black',
                      borderRadius: '50%',
                      width: 32,
                      height: 32,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      cursor: !viewOnly ? 'pointer' : 'default',
                    }}
                  >
                    <LockIcon />
                  </Box>
                )}
                <GameTeeTime Timestamp={Timestamp} teeTime={teaTime} />
              </Stack>
            </Stack>
          </Box>

          <Grid2 container sx={{ width: '100%' }} spacing={2}>
            {Array.from(groupedPlayers.entries()).map(([group, players]) => {
              if (!players || !Array.isArray(players)) return null;

              const thisGroupPlayers =
                match?.players?.filter((player) => player?.group === group) || [];
              const otherGroupPlayers =
                match?.players?.filter((player) => player?.group !== group) || [];
              const didWin = thisGroupPlayers?.[0]?.didWin;
              let text = 'X';
              if (didWin) {
                text = `${thisGroupPlayers?.[0]?.grossScore || 0}&${
                  otherGroupPlayers?.[0]?.grossScore || 0
                }`;
              }
              if (text === '1&0') {
                text = '1 Up';
              }
              const isHalved =
                thisGroupPlayers?.[0]?.grossScore === 0 &&
                otherGroupPlayers?.[0]?.grossScore === 0 &&
                match?.status === 'completed';

              return (
                <React.Fragment key={group}>
                  <Grid2 size={{ xs: 12, sm: 5 }} order={group === 'A' ? 0 : 2} sx={{ opacity: 1 }}>
                    <Box
                      sx={{
                        backgroundColor: palette.white,
                        borderRadius: '16px',
                        py: 3,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        height: '100%',
                        border: didWin
                          ? '4px solid #C8B359'
                          : selectedGroup === group && match?.status !== 'completed'
                          ? '4px solid black'
                          : '0px',
                      }}
                    >
                      <Stack
                        key={`group-${group}`}
                        direction="row"
                        spacing={2}
                        sx={{
                          justifyContent: 'space-around',
                          width: '100%',
                          height: '100%',
                        }}
                      >
                        {players.map((player, index) => {
                          console.log('player:', player);
                          return (
                            <Box sx={{ width: '50%' }}>
                              <GamePlayerInfo
                                player={player}
                                index={index}
                                photoUrl={getUserPhotoURL(player)}
                                winner={didWin}
                                size={{ width: 80, height: 80 }}
                              />
                            </Box>
                          );
                        })}
                      </Stack>
                      <Box sx={{ textAlign: 'center' }}>
                        {!isHalved && match?.status === 'completed' ? (
                          <Typography fontWeight={'bold'} sx={{ pt: 2 }}>
                            {text}
                          </Typography>
                        ) : match?.status === 'completed' ? (
                          <Box sx={{ pt: 2 }}>
                            <svg
                              width="80"
                              height="19"
                              viewBox="0 0 80 19"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0_2260_8012)">
                                <path
                                  d="M11.6527 13.2876C12.0433 13.6782 12.0433 14.3116 11.6527 14.7016C11.262 15.0922 10.6287 15.0922 10.2387 14.7016L7.14933 11.6122C6.88867 11.3516 6.46667 11.3516 6.20667 11.6122C5.946 11.8729 5.946 12.2949 6.20667 12.5549L9.014 15.3622C9.40467 15.7529 9.40467 16.3862 9.014 16.7762C8.62333 17.1669 7.99 17.1669 7.6 16.7762L4.48467 13.6609C2.514 11.7382 0.5 9.17489 0.5 6.73356C0.5 4.16023 2.444 2.06689 4.83333 2.06689C6.01533 2.06689 6.92067 2.50823 7.61 2.99823L5.184 5.40356C4.74267 5.84423 4.5 6.43089 4.5 7.05423C4.5 7.67756 4.74267 8.26356 5.18267 8.70356C5.62333 9.14489 6.20933 9.38756 6.83333 9.38756C7.11733 9.38756 7.39133 9.33089 7.65 9.23489L11.6533 13.2882L11.6527 13.2876ZM10.114 7.08356L8.71933 8.46889L12.7927 12.4809C13.1833 12.8716 13.8167 12.8716 14.2067 12.4809C14.804 11.8836 14.2927 11.2222 14.2927 11.2222L10.114 7.08356ZM12.138 2.10556C11.0487 2.11223 10.014 2.58556 9.21667 3.32823L6.12533 6.39889C5.73467 6.78956 5.73467 7.42289 6.12533 7.81289C6.516 8.20356 7.14933 8.20356 7.53933 7.81289L9.204 6.15956C9.724 5.64289 10.5627 5.64289 11.0833 6.15956L15.2993 10.3449C16.0933 9.06356 16.4987 7.86356 16.4987 6.77223C16.4987 4.19889 14.5267 2.10556 12.1373 2.10556H12.138Z"
                                  fill="black"
                                />
                              </g>
                              <path
                                d="M20.5304 15.4001V3.40015H22.8184V8.04015H29.9064V3.40015H32.1784V15.4001H29.9064V10.1041H22.8184V15.4001H20.5304ZM37.1893 15.5601C35.4293 15.5601 34.1173 14.7121 34.1173 13.1761C34.1173 11.6241 35.3973 10.9361 37.4933 10.5361L40.3413 10.0081C40.1333 9.25615 39.4933 8.90415 38.3893 8.90415C37.2213 8.90415 36.4213 9.30415 36.1493 10.1201L34.0533 9.81615C34.4693 8.24815 36.0053 7.20815 38.4053 7.20815C40.8693 7.20815 42.4853 8.36015 42.4853 10.4721V15.4001H40.5653L40.4533 14.2321C39.7813 15.0801 38.6133 15.5601 37.1893 15.5601ZM36.2933 13.0641C36.2933 13.6081 36.7253 13.8961 37.5253 13.8961C38.9493 13.8961 40.4213 13.1441 40.4213 11.6721V11.5281L37.6213 12.0561C36.7413 12.2481 36.2933 12.4881 36.2933 13.0641ZM44.6762 15.4001V3.40015H46.8042V15.4001H44.6762ZM51.6086 15.4001L48.0246 7.38415H50.3926L52.8406 13.1281L55.2726 7.38415H57.5446L53.9446 15.4001H51.6086ZM62.6803 15.5601C59.6563 15.5601 57.8483 13.8161 57.8483 11.4321C57.8483 9.00015 59.8163 7.20815 62.6163 7.20815C65.3043 7.20815 67.2083 8.77615 67.2083 11.0961C67.2083 11.3681 67.1603 11.7041 67.0963 12.0241H60.0083C60.2483 13.2401 61.2243 13.8161 62.6803 13.8161C63.9923 13.8161 64.7763 13.3841 65.1123 12.6801L67.1123 13.0961C66.5523 14.6641 64.9043 15.5601 62.6803 15.5601ZM60.0883 10.4561H64.9683C64.8083 9.48015 63.9283 8.88815 62.6163 8.88815C61.3843 8.88815 60.4403 9.41615 60.0883 10.4561ZM72.8294 15.5601C70.2054 15.5601 68.3014 13.8321 68.3014 11.3841C68.3014 8.95215 70.2054 7.20815 72.8294 7.20815C74.0614 7.20815 75.0854 7.60815 75.8054 8.29615V3.40015H77.9174V15.4001H75.9814L75.8854 14.4081C75.1494 15.1281 74.0934 15.5601 72.8294 15.5601ZM70.5094 11.3841C70.5094 12.7921 71.5654 13.6881 73.1494 13.6881C74.7654 13.6881 75.8054 12.7921 75.8054 11.3841C75.8054 9.97615 74.7654 9.08015 73.1494 9.08015C71.5654 9.08015 70.5094 9.97615 70.5094 11.3841Z"
                                fill="#112C11"
                              />
                              <defs>
                                <clipPath id="clip0_2260_8012">
                                  <rect
                                    width="16"
                                    height="16"
                                    fill="white"
                                    transform="translate(0.5 1.40015)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                          </Box>
                        ) : (
                          <ScoreCheckbox value={`group-${group}`} name="winner" />
                        )}
                      </Box>
                    </Box>
                  </Grid2>
                  {group === 'A' && (
                    <Grid2 size={{ xs: 12, sm: 2 }} order={1}>
                      {match?.status === 'completed' ? (
                        <Stack
                          direction="column"
                          spacing={2}
                          sx={{
                            justifyContent: 'space-around',
                            alignItems: 'center',
                            width: '100%',
                            height: '100%',
                            background:
                              match?.status === 'completed' ? 'transparent' : palette.white,
                            borderRadius: '16px',
                            pt: 1,
                          }}
                        >
                          <Box sx={{ textAlign: 'center', width: '100%' }}>
                            <svg
                              width="48"
                              height="48"
                              viewBox="0 0 48 48"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect width="48" height="48" rx="24" fill="#112C11" />
                              <path
                                d="M10.176 18H12.8L17.328 27.792L21.856 18H24.384L18.784 30H15.792L10.176 18ZM34.8424 21.68C34.4584 20.48 33.2264 19.808 31.0984 19.808C28.7464 19.808 27.6584 20.384 27.6584 21.248C27.6584 22.048 28.2344 22.336 29.9464 22.64L33.0664 23.168C35.8824 23.632 37.3224 24.544 37.3224 26.56C37.3224 28.688 35.0824 30.176 31.3544 30.176C27.8024 30.176 25.4184 28.912 24.6504 26.576L27.1304 25.984C27.5944 27.488 29.1144 28.192 31.3544 28.192C33.8024 28.192 34.8744 27.6 34.8744 26.672C34.8744 25.92 34.3624 25.552 32.5544 25.248L29.2744 24.688C26.5864 24.256 25.1944 23.328 25.1944 21.424C25.1944 19.264 27.6424 17.824 31.0984 17.824C34.4424 17.824 36.5864 18.976 37.2904 21.088L34.8424 21.68Z"
                                fill="white"
                              />
                            </svg>
                          </Box>
                        </Stack>
                      ) : (
                        <Stack
                          direction="column"
                          spacing={2}
                          sx={{
                            justifyContent: 'space-around',
                            alignItems: 'center',
                            width: '100%',
                            height: '100%',
                            background: palette.white,
                            borderRadius: '16px',
                            pt: 1,
                            border: isHalved ? '3px solid black' : '0px',
                          }}
                        >
                          <Box sx={{ textAlign: 'center', width: '100%' }}>
                            <HandshakeIcon />
                            <Typography variant="fieldLabel" component="p">
                              Halved
                            </Typography>
                          </Box>
                          <ScoreCheckbox value="halved" name="winner" />
                        </Stack>
                      )}
                    </Grid2>
                  )}
                </React.Fragment>
              );
            })}
          </Grid2>
          {match?.status === 'completed' ? (
            <Typography
              variant="body2"
              sx={{ textAlign: 'center', width: '150px', mb: 1 }}
            ></Typography>
          ) : !isHalved ? (
            <Stack direction="row" spacing={2} sx={{ alignItems: 'center', mt: 2, width: '100%' }}>
              <Typography variant="fieldLabel">Enter result</Typography>
              <Select
                sx={{
                  width: '75%',
                  ml: 2,
                  '& .MuiSelect-select': {
                    border: `2px solid ${palette.secondary}`,
                  },
                }}
                IconComponent={ExpandMoreOutlinedIcon}
                displayEmpty
                value={dropdownValue}
                onChange={(event) => {
                  const selectedOption = MatchPlayLookupTable.find(
                    (option) => option.name === event.target.value
                  );
                  setDropdownValue(event.target.value);
                  if (event.target.value === 'Halved') {
                    setIsHalved(true);
                    setSelectedGroup(null);
                    setGroupAScore('Halved');
                    setGroupBScore('Halved');
                  } else if (selectedOption) {
                    setIsHalved(false);
                    if (selectedGroup === 'A') {
                      setGroupAScore(selectedOption.winnerScore);
                      setGroupBScore(selectedOption.loserScore);
                    } else if (selectedGroup === 'B') {
                      setGroupAScore(selectedOption.loserScore);
                      setGroupBScore(selectedOption.winnerScore);
                    }
                  }
                }}
                renderValue={(selected) => {
                  if (selected === null || selected === undefined || selected === '') {
                    return <em>Select</em>;
                  }
                  return selected;
                }}
              >
                {MatchPlayLookupTable.map((option, index) => (
                  <MenuItem value={option.name} key={index}>
                    {option.name}
                  </MenuItem>
                ))}
              </Select>
            </Stack>
          ) : null}

          {match?.status !== 'completed' && (
            <Button
              variant="contained"
              disabled={isFinaliseButtonDisabled}
              sx={{ mt: 3, width: '100%' }}
              onClick={handleScoreMatchPlay}
            >
              {'Confirm Result'}
            </Button>
          )}
          {match?.status === 'completed' && !viewOnly && (
            <Typography variant="body2" sx={{ mt: 2, textAlign: 'center', opacity: 0.8 }}>
              Game has been scored, you can no longer update the result of the game.
            </Typography>
          )}
        </>
      )}
    </Paper>
  );
};

export default GameScoringMatchPlay;
